<template>
    <div class="architecture">
        <img src="../../../assets/images/architecture.png" alt="">
    </div>
</template>

<script>
export default {
    name: 'Architecture',
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.architecture{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
    text-align: center;
    padding: .3rem;
}
.architecture img{
    width: 3.6rem;
}
</style>